import {
  OPEN_DROPDOWN,
  CLOSE_DROPDOWN,
  INIT_DROPDOWN,
  NOTIFICATIONS_LOADED,
  NEW_NOTIFICATION,
  MARK_AS_READ
} from './action-types';

export function openDropdown() {

  return {
    type: OPEN_DROPDOWN
  };
}

export function closeDropdown() {

  return {
    type: CLOSE_DROPDOWN
  };
}

export function initDropdown() {

  return {
    type: INIT_DROPDOWN
  };
}

export function notificationsLoaded(notifications) {
  return {
    type: NOTIFICATIONS_LOADED,
    payload: notifications
  };
}


export function newNotification(notification) {
  return {
    type: NEW_NOTIFICATION,
    payload: notification
  };
}

/**
 * Si existe una notificación (en el state) que cumpla con el patrón dado, se 
 * encarga de marcar como leída.
 * 
 * @param {string} pattern 
 */
export function markNotificationAsRead(pattern) {
  return {
    type: MARK_AS_READ,
    payload: pattern
  };
}


// WEBPACK FOOTER //
// ./src/core/services/notifications/dropdown/action-creators.js